module.exports = __webpack_public_path__ + "media/exercise-tone.a9bcf815.mp3";